export const getImageUrl = (imageUrl, width, height) => {
  const filters = `w_${width},h_${height},c_fill,f_webp`

  return `${process.env.NEXT_PUBLIC_CLOUDINARY_PREFIX}/image/fetch/${filters}/${imageUrl}`
}
